import { IPromotionLogicInterface, PromotionTypes, PromotionBalanceEntryQualifier } from '@gongxigames/framework/promotions';

export class NullPromotion implements IPromotionLogicInterface {
    public hasPromotion(): boolean {
        return false;
    }

    public getType(): PromotionTypes {
        return PromotionTypes.NULL;
    }

    public getAdditionalFieldsForServerRequest(): Record<string, any> | undefined {
        return undefined;
    }

    public getBet(): number {
        return -1;
    }

    public getID(): string {
        return '';
    }

    public getPlayedRounds(): number {
        return 0;
    }

    public getRemainedRounds(): number {
        return 0;
    }

    public getTotalRounds(): number {
        return 0;
    }

    public getWin(): number {
        return 0;
    }

    public isActive(): boolean {
        return false;
    }

    public isCurrentInUse(): boolean {
        return false;
    }

    public isCurrentExpired(): boolean {
        return true;
    }

    public update(data: any): void {}
    public init(data: any): void {}
    public subtractPromotion(): void {}

    public getQualifier(): PromotionBalanceEntryQualifier {
        return 'free-round';
    }
}
